import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import SFIconButton from "../../../button/iconButton";
import { SFFullscreenIcon, SFFullscreenExitIcon } from "../../../icons";
import getStyled from "../../../../hooks/getStyled";
import { setFullScreen } from "../../../../redux/reducers/pageLayoutReducer";

const { styled } = getStyled();

const SFIconButtonStyled = styled(SFIconButton)(({ theme }) => ({
  backgroundColor: theme.palette.grey100.main,
  padding: "2px",
  // The background color should never change
  "&:hover": {
    backgroundColor: theme.palette.grey100.main,
  },
}));

const MinMaxAction = ({ onClick, disabled }) => {
  const isFullscreen = useSelector(
    (state) => state.pageLayout.fullScreen
  );

  const dispatch = useDispatch();

  const handleClick = () => {
    // Toggle the state of isFullscreen to change the rendered icon
    dispatch(setFullScreen(!isFullscreen));
    onClick();
  };

  return (
    <SFIconButtonStyled onClick={handleClick} disabled={disabled}>
      {isFullscreen ? (
        <SFFullscreenExitIcon color={!disabled ? "grey500" : "grey300"} />
      ) : (
        <SFFullscreenIcon color={!disabled ? "grey500" : "grey300"} />
      )}
    </SFIconButtonStyled>
  );
};

export default MinMaxAction;

MinMaxAction.propTypes = {
  // The function to call when the min-max action is clicked
  onClick: PropTypes.func.isRequired,
};
